// src/components/AdminRoute.jsx
import { Navigate } from "react-router-dom";

export default function AdminRoute({ children }) {
  const userStr = localStorage.getItem("user");

  // Si no hay usuario en localStorage -> fuera al login / inicio
  if (!userStr) {
    return <Navigate to="/" replace />;
  }

  const user = JSON.parse(userStr);

  // Si el usuario NO es admin -> lo mandas a una ruta permitida
  if (user.rol !== "admin") {
    return <Navigate to="/dashboard/asistencia" replace />;
  }

  // Si es admin, puede ver la ruta protegida
  return children;
}